import Grid from "@mui/material/Grid2";
import UsersDonutChart from "../UsersDonutChart";
import { StepDonutSection } from "../usersApiMapping";

interface UsersStepDonutSectionProps {
  section: StepDonutSection;
}

export default function UsersStepDonutSection({ section }: UsersStepDonutSectionProps) {
  return (
    <Grid container spacing={2.5}>
      <Grid size={{ xs: 12, md: 6 }}>
        <UsersDonutChart
          title={section.leadTitle}
          segments={section.leadSegments}
          centerValue={section.leadTotal}
          centerLabel="Leads"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <UsersDonutChart
          title={section.qualTitle}
          segments={section.qualSegments}
          centerValue={section.qualTotal}
          centerLabel="Qualified"
        />
      </Grid>
    </Grid>
  );
}
